import { styled } from "styled-components";

export const DrawerContainer = styled.div`   
    background: ${({ theme }) => theme.playerContentBackground};
    // box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15); 
    & .drawer-header-content {
        border-bottom : 1px solid ${({ theme }) => theme.playerDataBorder};
    }
`;

export const DrawerHeader = styled.div`   
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
    padding-bottom: 16px;
`;

export const SearchResults = styled.div`   
    background: ${({ theme }) => theme.searchResultsFooterBackground};
    backdrop-filter: blur(32px); 
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    -webkit-backdrop-filter:  blur(32px); 
`;

export const MatchDetailContainer = styled.div<{ isSelected: boolean }>`
    border: 1px solid ${({ isSelected, theme }) => (isSelected ? 'var(--Brand-green-1-500, #00D1A8)' : theme.playerCardBorderColor)};
    background: ${({ isSelected, theme }) => (isSelected ? 'var(--Brand-green-1-500, #00D1A8)' : theme.playerContentBackground)};
    & .descriptive-large-text {
        color:  ${({ isSelected }) => (isSelected ? '#111111' : "")};
    }
    &:hover {
        border: 1px solid var(--Brand-green-1-500, #00D1A8);
        background: var(--Brand-green-1-500, #00D1A8);
        & .descriptive-large-text {
            color: #111111;
        }
    }
`;